import { appConfig } from '../../../../../../../../../../../config/customization';

export default {
  containerHidden: {
    maxHeight: 0
  },
  containerShow: {
    maxHeight: 100,
    position: 'absolute',
    top: -10,
    right: 10,
    background: appConfig.colors.white,
    width: 230,
    borderRadius: 5,
    boxShadow: `0 8px 13px 0 ${appConfig.colors.translucentGray}`,
    transition: 'max-height 0.1s ease',
    zIndex: 999999,
    display: 'flex',
    flexDirection: 'row',
    padding: '20px 0px',
    justifyContent: 'space-around'
  },
  container: {
    display: 'flex',
    marginLeft: 10,
    marginRight: 10
  },
  button: {
    display: 'flex',
    position: 'relative'
  }
};
